import { SALESMAN_MASTER_KEYWORD_FILTER } from "constants/ActionTypes";

// คำค้นของหน้า list พนักงานขาย — contains จาก SalesmanCode หรือ SalesmanName (§5.1 ข้อ 1)
//
// คำค้นใน modal เขตการขายไม่ได้อยู่ใน redux โดยตั้งใจ — DialogSalesArea ถือเป็น state ภายใน
// ของ modal (เกิด/ตายพร้อม modal) การเก็บใน store จะทำให้ค่าค้างข้ามการเปิดครั้งถัดไป
export const salesmanMasterKeywordFilter = (payload) => {
    return {
        type: SALESMAN_MASTER_KEYWORD_FILTER,
        payload,
    };
};
